import React, { useState, useCallback } from "react";
import Icon from "@mdi/react";
import { mdiRefresh } from "@mdi/js";
import { cn } from "@/lib/utils";
import FadeIn from "./animations/FadeIn";

const EMBED_URL = "https://valentineshefuplease.netlify.app/";

interface ShowcaseProps {
  className?: string;
}

const Showcase: React.FC<ShowcaseProps> = ({ className }) => {
  const [reloadKey, setReloadKey] = useState(0);
  const handleReload = useCallback(() => setReloadKey((k) => k + 1), []);

  return (
    <section
      id="showcase"
      className={cn("py-20 bg-gradient-to-b from-gray-50 to-white", className)}
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <FadeIn>
            <h2 className="text-3xl md:text-4xl font-serif font-medium mb-6">
              See What We Create
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Here{'\''}s an example of a beautiful Sparks website we created. Each
              site is personalized with your loved one{'\''}s name and your special
              message.
            </p>
          </FadeIn>
        </div>

        <div className="max-w-6xl mx-auto">
          <FadeIn delay={200}>
            <div className="bg-white rounded-lg shadow-2xl overflow-hidden border">
              <div className="bg-gray-800 px-4 py-3 flex items-center gap-2">
                <div className="w-3 h-3 rounded-full bg-red-500"></div>
                <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                <div className="w-3 h-3 rounded-full bg-green-500"></div>
                <div className="ml-4 text-gray-400 text-sm font-mono flex-1 truncate">
                  valentineshefuplease.netlify.app
                </div>
                <button
                  type="button"
                  onClick={handleReload}
                  className="p-1.5 rounded text-gray-400 hover:text-white hover:bg-gray-600 transition-colors"
                  title="Reload"
                  aria-label="Reload embed"
                >
                  <Icon path={mdiRefresh} size={1} />
                </button>
              </div>

              <div className="relative">
                <iframe
                  key={reloadKey}
                  src={EMBED_URL}
                  className="w-full min-h-[32rem] h-[36rem] md:h-[42rem] border-0"
                  title="Sparks Example"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none"></div>
              </div>

              <div className="p-6 bg-gray-50">
                <h3 className="font-semibold text-gray-900 mb-2">
                  Features Include:
                </h3>
                <ul className="text-gray-600 space-y-1">
                  <li>• Personalized romantic message</li>
                  <li>• Beautiful gradient backgrounds</li>
                  <li>• Interactive Yes/No buttons</li>
                  <li>• Mobile-responsive design</li>
                  <li>• Custom domain available</li>
                </ul>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
};

export default Showcase;
